var _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_327_104803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 85
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 6,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_327_104803)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_104803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.2502C9 16.375 9.34768 15.5356 9.96655 14.9167C10.5854 14.2979 11.4248 13.9502 12.3 13.9502H34.8741C35.5199 13.9502 36.1515 14.1398 36.6907 14.4953C37.2298 14.8508 37.6528 15.3568 37.9072 15.9504L39.525 19.7252H71.7C72.5752 19.7252 73.4146 20.0729 74.0334 20.6917C74.6523 21.3106 75 22.15 75 23.0252V57.6752C75 58.5504 74.6523 59.3898 74.0334 60.0086C73.4146 60.6275 72.5752 60.9752 71.7 60.9752H12.3C11.4248 60.9752 10.5854 60.6275 9.96655 60.0086C9.34768 59.3898 9 58.5504 9 57.6752V17.2502Z",
    fill: "url(#paint0_linear_327_104803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0749 25.7476H65.9249C68.1249 25.7476 69.2249 26.8476 69.2249 29.0476V58.7476C69.2249 60.9476 68.1249 62.0476 65.9249 62.0476H18.0749C15.8749 62.0476 14.7749 60.9476 14.7749 58.7476V29.0476C14.7749 26.8476 15.8749 25.7476 18.0749 25.7476Z",
    fill: "url(#paint1_linear_327_104803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 30.4502H71.7C73.9 30.4502 75 31.5502 75 33.7502V66.7502C75 68.9502 73.9 70.0502 71.7 70.0502H12.3C10.1 70.0502 9 68.9502 9 66.7502V33.7502C9 31.5502 10.1 30.4502 12.3 30.4502Z",
    fill: "url(#paint2_linear_327_104803)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_327_104803",
    x1: 42,
    y1: 13.9502,
    x2: 42,
    y2: 33.2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB10E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_327_104803",
    x1: 41.9999,
    y1: 25.7476,
    x2: 41.9999,
    y2: 43.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_327_104803",
    x1: 42,
    y1: 30.4502,
    x2: 42,
    y2: 70.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB908"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_104803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder-icon.3f4cbeaf59faaed1b2ee4ac0e7f6751e.svg";